// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Checkbox_container__s9904 {
  display: flex;
  gap: 0.5rem;
  align-items: center;
  cursor: pointer;
}
.Checkbox_container__s9904[data-disabled=true] {
  cursor: not-allowed;
}

.Checkbox_checkbox__iAXAj {
  width: 18px;
  height: 18px;
  background-color: white;
  display: inline-block;
  vertical-align: top;
  border: 1px solid #454545;
  border-radius: 2px;
}
.Checkbox_checkbox__iAXAj svg {
  vertical-align: top;
}
.Checkbox_checkbox__iAXAj[data-highlightRed=true] {
  border-color: red;
}
.Checkbox_checkbox__iAXAj[data-checked=true] {
  background-color: #BCCF00;
  border: 1px solid #BCCF00;
}
.Checkbox_checkbox__iAXAj[data-disabled=true] {
  border-color: lightgray;
  background-color: lightgray;
}`, "",{"version":3,"sources":["webpack://./src/components/Misc/Checkbox.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,WAAA;EACA,mBAAA;EACA,eAAA;AACF;AACE;EACE,mBAAA;AACJ;;AAGA;EACE,WAAA;EACA,YAAA;EACA,uBAAA;EACA,qBAAA;EACA,mBAAA;EAEA,yBAAA;EACA,kBAAA;AADF;AAGE;EACE,mBAAA;AADJ;AAIE;EACE,iBAAA;AAFJ;AAKE;EACE,yBAAA;EACA,yBAAA;AAHJ;AAME;EACE,uBAAA;EACA,2BAAA;AAJJ","sourcesContent":[".container {\n  display: flex;\n  gap: 0.5rem;\n  align-items: center;\n  cursor: pointer;\n}\n.container[data-disabled=true] {\n  cursor: not-allowed;\n}\n\n.checkbox {\n  width: 18px;\n  height: 18px;\n  background-color: white;\n  display: inline-block;\n  vertical-align: top;\n  border: 1px solid #454545;\n  border-radius: 2px;\n}\n.checkbox svg {\n  vertical-align: top;\n}\n.checkbox[data-highlightRed=true] {\n  border-color: red;\n}\n.checkbox[data-checked=true] {\n  background-color: #BCCF00;\n  border: 1px solid #BCCF00;\n}\n.checkbox[data-disabled=true] {\n  border-color: lightgray;\n  background-color: lightgray;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Checkbox_container__s9904`,
	"checkbox": `Checkbox_checkbox__iAXAj`
};
export default ___CSS_LOADER_EXPORT___;
